import axios from 'axios';
import router from '../router';

let state = {
    selectedCustomPart1: undefined,
    selectedCustomPart2: undefined,
    selectedCustomPart3: undefined,

    motorColorSelection: [],
    motorLogoSelection: [],
    motorOperatingInstructionSelection: [],
    deliverOperatingInstructionSelection: [],
    cableGlandSelection: [],
    quantityOperatingInstructions: 0,
    customPart_Modal_Shown: false,
    customPartSelection: [],
    ratingPlateLayoutDetails: undefined,
    massbl: undefined,

    projekt: undefined,
    sanum: undefined,
    inok: undefined,
    onok: undefined,
    mvlift: { value: null, invalid: false },
    mis: { value: null, invalid: false },

    inok_necessary: false,
    onok_necessary: false,
    mvlift_necessary: false,
    mis_necessary: false,
    sanum_necessary: false,
}

const actions = {

    change_suppliesMotorManual_toDefault_storeAction({ commit, dispatch }) {
        commit('change_selectedCustomPart1_storeMutation', null);
        commit('change_selectedCustomPart2_storeMutation', null);
        commit('change_selectedCustomPart3_storeMutation', null);
        commit('change_motorColorSelection_storeMutation', []);
        commit('change_motorLogoSelection_storeMutation', []);
        commit('change_motorOperatingInstructionSelection_storeMutation', []);
        commit('change_deliverOperatingInstructionSelection_storeMutation', []);
        commit('change_cableGlandSelection_storeMutation', []);
        commit('change_quantityOperatingInstructions_storeMutation', 0);
        commit('change_customPart_Modal_Shown_storeMutation', false);
        commit('change_customPartNumber_storeMutation', null);
        commit('change_customPartSelection_storeMutation', []);
        commit('change_ratingPlateLayoutLanguage_storeMutation', null);
        commit('change_massbl_storeMutation', null);
        commit('change_mvlift_storeMutation', { value: null, invalid: false });
        commit('change_mis_storeMutation', { value: null, invalid: false });
        commit('change_projekt_storeMutation', null);
        commit('change_sanum_storeMutation', null);
        commit('change_inok_storeMutation', null);
        commit('change_onok_storeMutation', null);
        commit('change_inok_necessary_storeMutation', false);
        commit('change_onok_necessary_storeMutation', false);
        commit('change_sanum_necessary_storeMutation', false);
        commit('change_mvlift_necessary_storeMutation', false);
        commit('change_mis_necessary_storeMutation', false);
    },

    async get_suppliesInformations_storeAction({ rootState, commit, dispatch }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
        }
        await axios({
            method: 'post',
            url: '/api/suppliesMotorManual/get_suppliesInformations',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);

                if ((response.data.status.statusCode.substring(0, 1) == '2') || (response.data.status.statusCode.substring(0, 2) == '74') || (response.data.status.statusCode.substring(0, 2) == '75')) {
                    commit('change_motorColorSelection_storeMutation', response.data.data.motorColorSelection);
                    commit('change_motorLogoSelection_storeMutation', response.data.data.motorLogoSelection);
                    commit('change_motorOperatingInstructionSelection_storeMutation', response.data.data.motorOperatingInstructionSelection);
                    commit('change_cableGlandSelection_storeMutation', response.data.data.cableGlandSelection);
                    commit('change_ratingPlateLayoutLanguage_storeMutation', response.data.data.ratingPlateLayoutDetails);
                    commit('change_massbl_storeMutation', response.data.data.massbl);
                    commit('change_deliverOperatingInstructionSelection_storeMutation', response.data.data.deliverOperatingInstructionSelection);

                    dispatch('change_projekt_storeAction', response.data.data.projekt);
                    dispatch('change_sanum_storeAction', response.data.data.sanum);
                    dispatch('change_inok_storeAction', response.data.data.inok);
                    dispatch('change_onok_storeAction', response.data.data.onok);
                    dispatch('change_mvlift_storeAction', response.data.data.mvLift);
                    dispatch('change_mis_storeAction', response.data.data.mis);

                    commit('change_inok_necessary_storeMutation', response.data.data.inoK_Necessary);
                    commit('change_onok_necessary_storeMutation', response.data.data.onoK_Necessary);
                    commit('change_mvlift_necessary_storeMutation', response.data.data.mvlift_Necessary);
                    commit('change_mis_necessary_storeMutation', response.data.data.mis_Necessary);
                    commit('change_sanum_necessary_storeMutation', response.data.data.sanuM_Necessary);

                    dispatch('change_quantityOperatingInstructions_storeAction');

                    commit('change_customPartSelection_storeMutation', response.data.data.customPartSelection);
                    if (state.customPartSelection != null && state.customPartSelection.length > 0 && response.data.data.selectedCustomPart1 != null) {
                        const firstIndex_whichMeetConditions_selectedCutomPart1 = state.customPartSelection.findIndex(i => (i.blockNumber == response.data.data.selectedCustomPart1));
                        if (firstIndex_whichMeetConditions_selectedCutomPart1 > -1) {
                            commit('change_selectedCustomPart1_storeMutation', state.customPartSelection[firstIndex_whichMeetConditions_selectedCutomPart1])
                            commit('change_customPartSelected_storeMutation', response.data.data.selectedCustomPart1)
                        }
                    }
                    if (state.customPartSelection != null && state.customPartSelection.length > 0 && response.data.data.selectedCustomPart2 != null) {
                        const firstIndex_whichMeetConditions_selectedCutomPart2 = state.customPartSelection.findIndex(i => (i.blockNumber == response.data.data.selectedCustomPart2));
                        if (firstIndex_whichMeetConditions_selectedCutomPart2 > -1) {
                            commit('change_selectedCustomPart2_storeMutation', state.customPartSelection[firstIndex_whichMeetConditions_selectedCutomPart2])
                            commit('change_customPartSelected_storeMutation', response.data.data.selectedCustomPart2)
                        }
                    }
                    if (state.customPartSelection != null && state.customPartSelection.length > 0 && response.data.data.selectedCustomPart3 != null) {
                        const firstIndex_whichMeetConditions_selectedCutomPart3 = state.customPartSelection.findIndex(i => (i.blockNumber == response.data.data.selectedCustomPart3));
                        if (firstIndex_whichMeetConditions_selectedCutomPart3 > -1) {
                            commit('change_selectedCustomPart3_storeMutation', state.customPartSelection[firstIndex_whichMeetConditions_selectedCutomPart3])
                            commit('change_customPartSelected_storeMutation', response.data.data.selectedCustomPart3)
                        }
                    }
                }
            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    change_Selected_motorColor_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.blockNumberColor;
        commit('change_motorColorSelected_storeMutation', _value);
    },

    change_Selected_motorLogo_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.text.text;
        commit('change_motorLogoSelected_storeMutation', _value);
    },

    change_Selected_operatingInstruction_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.text.text;
        commit('change_operatingInstructionSelected_storeMutation', _value);

        dispatch('change_quantityOperatingInstructions_storeAction');
    },

    change_Selected_deliverOperatingInstruction_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.text.text;
        commit('change_deliverOperatingInstructionSelected_storeMutation', _value);
    },

    change_quantityOperatingInstructions_storeAction({ commit, getters }) {
        var number = getters.motorOperatingInstructionListSelected.length;
        if (number == null) {
            number = 0;
        }
        commit('change_quantityOperatingInstructions_storeMutation', number)
    },

    change_Selected_cableGland_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.text.text;
        commit('change_cableGlandSelected_storeMutation', _value);
    },

    async change_customPart_Modal_Shown_storeAction({ commit, dispatch }, value) {
        commit('change_customPart_Modal_Shown_storeMutation', value)
    },
    set_customPartModal_Shown_storeAction({ commit, dispatch }, value) {
        commit('change_customPart_Modal_Shown_storeMutation', true);
        commit('change_customPartNumber_storeMutation', value);

        if (state.customPartNumber == 1 && state.selectedCustomPart1 != null && state.selectedCustomPart1.hasOwnProperty('blockNumber') && state.selectedCustomPart1.blockNumber != null) {
            commit('change_customPartSelected_storeMutation', state.selectedCustomPart1.blockNumber)
        }
        else if (state.customPartNumber == 2 && state.selectedCustomPart2 != null && state.selectedCustomPart2.hasOwnProperty('blockNumber') && state.selectedCustomPart2.blockNumber != null) {
            commit('change_customPartSelected_storeMutation', state.selectedCustomPart2.blockNumber)
        }
        else if (state.customPartNumber == 3 && state.selectedCustomPart3 != null && state.selectedCustomPart3.hasOwnProperty('blockNumber') && state.selectedCustomPart3.blockNumber != null) {
            commit('change_customPartSelected_storeMutation', state.selectedCustomPart3.blockNumber)
        }
        else {
            commit('change_customPartSelected_storeMutation', state.customPartSelection[0].blockNumber)
        }
    },
    change_customPartModal_Shown_storeAction({ commit, dispatch }, value) {
        if (value == 1) {
            const firstIndex_whichMeetCondition = state.customPartSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetCondition > -1) {
                if (state.customPartNumber == 1) {
                    commit('change_selectedCustomPart1_storeMutation', state.customPartSelection[firstIndex_whichMeetCondition])
                }
                else if (state.customPartNumber == 2) {
                    commit('change_selectedCustomPart2_storeMutation', state.customPartSelection[firstIndex_whichMeetCondition])
                }
                else if (state.customPartNumber == 3) {
                    commit('change_selectedCustomPart3_storeMutation', state.customPartSelection[firstIndex_whichMeetCondition])
                }
            }
        }
        commit('change_customPartNumber_storeMutation', null);
        commit('change_customPartSelected_storeMutation', null);
        commit('change_customPart_Modal_Shown_storeMutation', false);
    },
    change_Selected_customPart_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.blockNumber;
        commit('change_customPartSelected_storeMutation', _value);
    },
    change_Selected_quantity1_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.value;
        commit('change_quantity1Selected_storeMutation', _value);
    },
    change_Selected_quantity2_storeAction({ commit, dispatch }, value) {
        const _value = value == null ? null : value.value;
        commit('change_quantity2Selected_storeMutation', _value);
    },

    checkIf_suppliesMotorManual_areValid_storeAction({ rootState, dispatch, getters }) {
        var numberOf_inputs_whichAreInvalid = 0;

        if (getters.selectedMotorColor_mN_FARBE == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.selectedLogo_lLOGO == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        var motorOperatingInstructions = getters.motorOperatingInstructionListSelected;
        if (motorOperatingInstructions == null || motorOperatingInstructions.length == 0) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (getters.ratingPlateLayountDetails_lLab01 == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (getters.selectedQuantity1 == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.deliverOperatingInstructionSelection != null) {
            if (getters.selectedDeliverOperatingInstruction == null) {
                numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
            }
        }
        else {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (state.mvlift != null && (state.mvlift.hasOwnProperty('value') == false || state.mvlift.invalid == true)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (state.mis != null && (state.mis.hasOwnProperty('value') == false || state.mis.invalid == true)) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (state.inok_necessary == true && state.inok == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.onok_necessary == true && state.onok == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }
        if (state.sanum_necessary == true && state.sanum == null) {
            numberOf_inputs_whichAreInvalid = numberOf_inputs_whichAreInvalid + 1;
        }

        if (numberOf_inputs_whichAreInvalid > 0) {
            this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 1446 }, { textKey: 1449 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
        }
        else if (numberOf_inputs_whichAreInvalid == 0) {
            dispatch('insertOrUpdate_suppliesMotorManual_storeAction')
        }
    },

    async insertOrUpdate_suppliesMotorManual_storeAction({ rootState, dispatch, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        var suppliesMotorManual = {};
        suppliesMotorManual.mN_FARBE = getters.selectedMotorColor_mN_FARBE;
        suppliesMotorManual.fARBE = getters.selectedMotorColor_fARBE;
        suppliesMotorManual.mFARBE = getters.selectedMotorColor_mFARBE;
        suppliesMotorManual.mHAERT = getters.selectedMotorColor_mHAERT;
        suppliesMotorManual.tNHAERT = getters.selectedMotorColor_tNHAERT;
        suppliesMotorManual.tNC4G = getters.selectedMotorColor_tnc4g;
        suppliesMotorManual.tNC4GH = getters.selectedMotorColor_tnc4gh;

        suppliesMotorManual.mN_LOGO = getters.selectedLogo_mN_LOGO;
        suppliesMotorManual.lLOGO = getters.selectedLogo_lLOGO;

        var motorOperatingInstructions = getters.motorOperatingInstructionListSelected;
        suppliesMotorManual.lBAL = getters.selected_LBAL;

        suppliesMotorManual.mN_BAL1 = getters.mN_BAL1;
        suppliesMotorManual.bALSP1 = getters.bALSP1;
        suppliesMotorManual.bALME1 = getters.bALME1;

        suppliesMotorManual.mN_BAL2 = getters.mN_BAL2;
        suppliesMotorManual.bALSP2 = getters.bALSP2;
        suppliesMotorManual.bALME2 = getters.bALME2;

        suppliesMotorManual.mN_BAL3 = getters.mN_BAL3;
        suppliesMotorManual.bALSP3 = getters.bALSP3;
        suppliesMotorManual.bALME3 = getters.bALME3;

        suppliesMotorManual.tNKVML = getters.selectedCableGland_tNKVML;
        suppliesMotorManual.cableGlandSelected = getters.selectedCableGland_selected;

        if (state.selectedCustomPart1 != null) {
            suppliesMotorManual.mN_KDMAT1 = state.selectedCustomPart1.blockNumber;
            suppliesMotorManual.customPart1 = state.selectedCustomPart1.text.text;
        }
        if (state.selectedCustomPart2 != null) {
            suppliesMotorManual.mN_KDMAT2 = state.selectedCustomPart2.blockNumber;
            suppliesMotorManual.customPart2 = state.selectedCustomPart2.text.text;
        }
        if (state.selectedCustomPart3 != null) {
            suppliesMotorManual.mN_KDMAT3 = state.selectedCustomPart3.blockNumber;
            suppliesMotorManual.customPart3 = state.selectedCustomPart3.text.text;
        }

        suppliesMotorManual.lLab01 = getters.ratingPlateLayountDetails_lLab01;
        suppliesMotorManual.lLab02 = getters.ratingPlateLayountDetails_lLab02;

        suppliesMotorManual.nL01 = getters.ratingPlateLayountDetails_nL01;
        suppliesMotorManual.nL02 = getters.ratingPlateLayountDetails_nL02;
        suppliesMotorManual.kulogo = state.ratingPlateLayoutDetails.kulogo;
        suppliesMotorManual.x_LSD = state.ratingPlateLayoutDetails.x_LSD;
        suppliesMotorManual.nL03 = state.ratingPlateLayoutDetails.nL03;
        suppliesMotorManual.aL01 = state.ratingPlateLayoutDetails.aL01;

        suppliesMotorManual.projekt = state.projekt;
        suppliesMotorManual.sanum = state.sanum;
        suppliesMotorManual.inok = state.inok;
        suppliesMotorManual.onok = state.onok;
        suppliesMotorManual.mvLift = (state.mvlift != null && state.mvlift.hasOwnProperty('value')) ? state.mvlift.value : null;
        suppliesMotorManual.mis = (state.mis != null && state.mis.hasOwnProperty('value')) ? state.mis.value : null;

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            suppliesMotorManual: suppliesMotorManual,
        }
        await axios({
            method: 'post',
            url: '/api/configurations/insertOrUpdate_suppliesMotorManual',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);

                if (rootState.configurations.plusManual == false) {
                    if (response.data.status.statusCode.substring(0, 1) == '2') {
                        if (response.data.data.changedDataset == true) {
                        }
                        router.push({ params: { slug: 'packagingMotorManual' } })
                    }
                    else {
                    }
                }

            })
            .catch(() => { })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    change_projekt_storeAction({ commit }, value) {
        commit('change_projekt_storeMutation', value);
    },
    change_sanum_storeAction({ commit }, value) {
        commit('change_sanum_storeMutation', value);
    },
    change_inok_storeAction({ commit }, value) {
        commit('change_inok_storeMutation', value);
    },
    change_onok_storeAction({ commit }, value) {
        commit('change_onok_storeMutation', value);
    },
    change_mvlift_storeAction({ commit }, value) {
        if (value != null && value != '') {
            const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
            valueAndValueValidationCriteria.value = value;
            valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.decimal;
            valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = 2;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThanOrEqualTo;
            valueAndValueValidationCriteria.permissibleValueRange.maximum.value = null;
            valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = null;
            const quantity_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

            commit('change_mvlift_storeMutation', quantity_ValidationResult);
        }
        else {
            commit('change_mvlift_storeMutation', { value: null, invalid: false });
        }
    },
    change_mis_storeAction({ commit }, value) {
        if (value != null && value != '') {
            const valueAndValueValidationCriteria = this._vm.$transmit_valueAndValueValidationCriteria;
            valueAndValueValidationCriteria.value = value;
            valueAndValueValidationCriteria.dataType = this._vm.$dataTypes.integer;
            valueAndValueValidationCriteria.permissibleNumberOfDecimalPlaces = null;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.value = 0;
            valueAndValueValidationCriteria.permissibleValueRange.minimum.operator = this._vm.$operators.greaterThanOrEqualTo;
            valueAndValueValidationCriteria.permissibleValueRange.maximum.value = null;
            valueAndValueValidationCriteria.permissibleValueRange.maximum.operator = null;
            const quantity_ValidationResult = this._vm.$checkIf_value_isValid(valueAndValueValidationCriteria);

            commit('change_mis_storeMutation', quantity_ValidationResult);
        }
        else {
            commit('change_mis_storeMutation', { value: null, invalid: false });
        }
    },
}

const mutations = {
    change_motorColorSelection_storeMutation(state, payload) {
        state.motorColorSelection = payload;
    },
    change_motorLogoSelection_storeMutation(state, payload) {
        state.motorLogoSelection = payload;
    },
    change_motorOperatingInstructionSelection_storeMutation(state, payload) {
        state.motorOperatingInstructionSelection = payload;
    },
    change_deliverOperatingInstructionSelection_storeMutation(state, payload) {
        state.deliverOperatingInstructionSelection = payload;
    },
    change_cableGlandSelection_storeMutation(state, payload) {
        state.cableGlandSelection = payload;
    },
    change_ratingPlateLayoutLanguage_storeMutation(state, payload) {
        state.ratingPlateLayoutDetails = payload;
    },
    change_massbl_storeMutation(state, payload) {
        state.massbl = payload;
    },
    change_motorColorSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorColorSelection.length; i++) {
            state.motorColorSelection[i].selected = false;
            if (state.motorColorSelection[i].blockNumberColor == payload) {
                state.motorColorSelection[i].selected = true;
            }
        }
    },
    change_motorLogoSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorLogoSelection.length; i++) {
            state.motorLogoSelection[i].selected = false;
            if (state.motorLogoSelection[i].text.text == payload) {
                state.motorLogoSelection[i].selected = true;
            }
        }
    },
    change_operatingInstructionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.motorOperatingInstructionSelection.length; i++) {
            if (payload == null) {
                state.motorOperatingInstructionSelection[i].selected = false;
            }
            if (state.motorOperatingInstructionSelection[i].text.text == payload) {
                if (state.motorOperatingInstructionSelection[i].selected == true) {
                    state.motorOperatingInstructionSelection[i].selected = false;
                }
                else {
                    state.motorOperatingInstructionSelection[i].selected = true;
                }
            }
        }
    },
    change_deliverOperatingInstructionSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.deliverOperatingInstructionSelection.length; i++) {
            state.deliverOperatingInstructionSelection[i].selected = false;
            if (state.deliverOperatingInstructionSelection[i].text.text == payload) {
                state.deliverOperatingInstructionSelection[i].selected = true;
            }
        }
    },

    change_cableGlandSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.cableGlandSelection.length; i++) {
            state.cableGlandSelection[i].selected = false;
            if (state.cableGlandSelection[i].text.text == payload) {
                state.cableGlandSelection[i].selected = true;
            }
        }
    },
    change_customPartSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.customPartSelection.length; i++) {
            state.customPartSelection[i].selected = false;
            if (state.customPartSelection[i].blockNumber == payload) {
                state.customPartSelection[i].selected = true;
            }
        }
    },
    change_quantity1Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.ratingPlateLayoutDetails.quantity1.length; i++) {
            state.ratingPlateLayoutDetails.quantity1[i].selected = false;
            if (state.ratingPlateLayoutDetails.quantity1[i].value == payload) {
                state.ratingPlateLayoutDetails.quantity1[i].selected = true;
            }
        }
    },
    change_quantity2Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.ratingPlateLayoutDetails.quantity2.length; i++) {
            state.ratingPlateLayoutDetails.quantity2[i].selected = false;
            if (state.ratingPlateLayoutDetails.quantity2[i].value == payload) {
                state.ratingPlateLayoutDetails.quantity2[i].selected = true;
            }
        }
    },
    change_quantityOperatingInstructions_storeMutation(state, payload) {
        state.quantityOperatingInstructions = payload;
    },
    change_customPart_Modal_Shown_storeMutation(state, payload) {
        state.customPart_Modal_Shown = payload;
    },
    change_customPartNumber_storeMutation(state, payload) {
        state.customPartNumber = payload;
    },
    change_customPartSelection_storeMutation(state, payload) {
        state.customPartSelection = payload;
    },
    change_selectedCustomPart1_storeMutation(state, payload) {
        state.selectedCustomPart1 = payload;
    },
    change_selectedCustomPart2_storeMutation(state, payload) {
        state.selectedCustomPart2 = payload;
    },
    change_selectedCustomPart3_storeMutation(state, payload) {
        state.selectedCustomPart3 = payload;
    },
    change_projekt_storeMutation(state, payload) {
        state.projekt = payload;
    },
    change_sanum_storeMutation(state, payload) {
        state.sanum = payload;
    },
    change_inok_storeMutation(state, payload) {
        state.inok = payload;
    },
    change_onok_storeMutation(state, payload) {
        state.onok = payload;
    },
    change_mvlift_storeMutation(state, payload) {
        state.mvlift = payload;
    },
    change_mis_storeMutation(state, payload) {
        state.mis = payload;
    },
    change_inok_necessary_storeMutation(state, payload) {
        state.inok_necessary = payload;
    },
    change_onok_necessary_storeMutation(state, payload) {
        state.onok_necessary = payload;
    },
    change_mvlift_necessary_storeMutation(state, payload) {
        state.mvlift_necessary = payload;
    },
    change_mis_necessary_storeMutation(state, payload) {
        state.mis_necessary = payload;
    },

    change_sanum_necessary_storeMutation(state, payload) {
        state.sanum_necessary = payload;
    },
}

const getters = {
    selectedMotorColor: (state, getters, rootState, rootGetters) => {
        const color_List = state.motorColorSelection;
        return color_List != null
            && Array.isArray(color_List)
            ? color_List.find(i => i.selected == true) || null
            : null;
    },
    selectedMotorColor_mN_FARBE: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.blockNumberColor
            : null;
    },
    selectedMotorColor_fARBE: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.text.text
            : null;
    },
    selectedMotorColor_mFARBE: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.quantityColor
            : null;
    },
    selectedMotorColor_mHAERT: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.quantityHardener
            : null;
    },
    selectedMotorColor_tNHAERT: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.blockNumberHardener
            : null;
    },
    selectedMotorColor_tnc4g: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.tnc4g
            : null;
    },
    selectedMotorColor_tnc4gh: (state, getters, rootState, rootGetters) => {
        const color = getters.selectedMotorColor;
        return color != null
            ? color.tnc4gh
            : null;
    },

    selectedLogo: (state, getters, rootState, rootGetters) => {
        const logo_List = state.motorLogoSelection;
        return logo_List != null
            && Array.isArray(logo_List)
            ? logo_List.find(i => i.selected == true) || null
            : null;
    },
    selectedLogo_mN_LOGO: (state, getters, rootState, rootGetters) => {
        const logo = getters.selectedLogo;
        return logo != null
            ? logo.blockNumber
            : null;
    },
    selectedLogo_lLOGO: (state, getters, rootState, rootGetters) => {
        const logo = getters.selectedLogo;
        return logo != null
            ? logo.text.code
            : null;
    },
    selectedCableGland: (state, getters, rootState, rootGetters) => {
        const cableGland_List = state.cableGlandSelection;
        return cableGland_List != null
            && Array.isArray(cableGland_List)
            ? cableGland_List.find(i => i.selected == true) || null
            : null;
    },
    selectedCableGland_tNKVML: (state, getters, rootState, rootGetters) => {
        const cableGland = getters.selectedCableGland;
        return cableGland != null
            ? cableGland.blockNumber
            : null;
    },
    selectedCableGland_selected: (state, getters, rootState, rootGetters) => {
        const cableGland = getters.selectedCableGland;
        return cableGland != null
            ? cableGland.selected
            : null;
    },
    selectedQuantity1: (state, getters, rootState, rootGetters) => {
        const layout = state.ratingPlateLayoutDetails;
        return layout != null
            && layout.hasOwnProperty('quantity1')
            && layout.quantity1 != null
            && Array.isArray(layout.quantity1)
            ? layout.quantity1.find(i => i.selected == true) || null
            : null;
    },
    ratingPlateLayountDetails_nL01: (state, getters, rootState, rootGetters) => {
        const nL = getters.selectedQuantity1;
        return nL != null
            && nL.hasOwnProperty('value')
            ? nL.value
            : null
    },
    selectedQuantity2: (state, getters, rootState, rootGetters) => {
        const layout = state.ratingPlateLayoutDetails;
        return layout != null
            && layout.hasOwnProperty('quantity2')
            && layout.quantity2 != null
            && Array.isArray(layout.quantity2)
            ? layout.quantity2.find(i => i.selected == true) || null
            : null;
    },
    ratingPlateLayountDetails_nL02: (state, getters, rootState, rootGetters) => {
        const nL = getters.selectedQuantity2
        return nL != null
            && nL.hasOwnProperty('value')
            ? nL.value
            : null
    },

    ratingPlateLayountDetails_lLab01: (state, getters, rootState, rootGetters) => {
        const layout = state.ratingPlateLayoutDetails;
        return layout != null
            && layout.hasOwnProperty('language1')
            && layout.language1 != null
            && layout.language1.hasOwnProperty('text')
            ? layout.language1.text.text
            : null;
    },
    ratingPlateLayountDetails_lLab02: (state, getters, rootState, rootGetters) => {
        const layout = state.ratingPlateLayoutDetails;
        return layout != null
            && layout.hasOwnProperty('language2')
            && layout.language2 != null
            && layout.language2.hasOwnProperty('text')
            ? layout.language2.text.text
            : null;
    },
    motorOperatingInstructionListSelected: (state, getters, rootState, rootGetters) => {
        const BAL_List = state.motorOperatingInstructionSelection;
        return BAL_List != null ? BAL_List.filter(i => i.selected == true) : [];
    },
    arrayLength_BAL: (state, getters, rootState, rootGetters) => {
        const BAL_List_Selected = getters.motorOperatingInstructionListSelected;
        return BAL_List_Selected != null ? BAL_List_Selected.length : 0;
    },
    BAL1: (state, getters, rootState, rootGetters) => {
        return getters.arrayLength_BAL > 0 ? getters.motorOperatingInstructionListSelected[0] : null;
    },
    BAL2: (state, getters, rootState, rootGetters) => {
        return getters.arrayLength_BAL > 1 ? getters.motorOperatingInstructionListSelected[1] : null;
    },
    BAL3: (state, getters, rootState, rootGetters) => {
        return getters.arrayLength_BAL > 2 ? getters.motorOperatingInstructionListSelected[2] : null;
    },
    mN_BAL1: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL1
        return BAL != null && BAL.hasOwnProperty('blockNumber') ? BAL.blockNumber : null;
    },
    bALSP1: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL1;
        return BAL != null && BAL.hasOwnProperty('text') ? BAL.text.text : null;
    },
    bALME1: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL1;
        return BAL != null && BAL.hasOwnProperty('quantity') ? isNaN(parseInt(BAL.quantity)) == false ? BAL.quantity : 1 : null;
    },
    mN_BAL2: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL2
        return BAL != null && BAL.hasOwnProperty('blockNumber') ? BAL.blockNumber : null;
    },
    bALSP2: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL2;
        return BAL != null && BAL.hasOwnProperty('text') ? BAL.text.text : null;
    },
    bALME2: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL2;
        return BAL != null && BAL.hasOwnProperty('quantity') ? isNaN(parseInt(BAL.quantity)) == false ? BAL.quantity : 1 : null;
    },
    mN_BAL3: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL3
        return BAL != null && BAL.hasOwnProperty('blockNumber') ? BAL.blockNumber : null;
    },
    bALSP3: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL3;
        return BAL != null && BAL.hasOwnProperty('text') ? BAL.text.text : null;
    },
    bALME3: (state, getters, rootState, rootGetters) => {
        const BAL = getters.BAL3;
        return BAL != null && BAL.hasOwnProperty('quantity') ? isNaN(parseInt(BAL.quantity)) == false ? BAL.quantity : 1 : null;
    },
    selectedDeliverOperatingInstruction: (state, getters, rootState, rootGetters) => {
        const LBAL_List = state.deliverOperatingInstructionSelection;
        return LBAL_List != null && Array.isArray(LBAL_List) ? LBAL_List.find(i => i.selected == true) || null : null;
    },
    selected_LBAL: (state, getters, rootState, rootGetters) => {
        const LBAL = getters.selectedDeliverOperatingInstruction
        return getters.arrayLength_BAL > 0 && LBAL != null && LBAL.hasOwnProperty('text') ? LBAL.text.code : null;
    },
}

export const suppliesMotorManual = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations,
    getters,
}